import Layout from '@/components/Layout.vue'

export default {
    path:"/contentManager",
    component: Layout,
    name: 'Layout',
    redirect:"/contentManager/homeBanner",
    meta: {
        title: "内容"
    },
    children:[
        {
            path: "homeBanner",
            name: 'homeBanner',
            meta: {
                title: "首页banner",
                pagetitle: "首页banner"
            },
            component: () => import('@/views/contentManager/homeBanner.vue'),
        },
        {
            path: "personal-center",
            component: { template: '<router-view />'},
            meta: {
                title: "个人中心-主页配置",
                pagetitle: "个人中心-主页配置",
                // 是否显示页面header组件
                showHeader: true,
                showTabs: true
            },
            children: [
                {
                    path: "home",
                    component: () => import('@/views/contentManager/personal-center/home/view.vue'),
                    meta: { name: "主页banner", accessId: "200727", btnsAccess: { modify: "200730" } }
                },
                {
                    path: "info-bar",
                    component: () => import('@/views/contentManager/personal-center/info-bar/view.vue'),
                    meta: { name: "信息条", accessId: "200728", btnsAccess: { modify: "200731" } }
                },
                {
                    path: "shiquan",
                    component: () => import('@/views/contentManager/personal-center/shiquan/view.vue'),
                    meta: { name: "玩转狮圈儿", accessId: '200729', btnsAccess: { modify: "200732" } }
                },
            ]
        },
        {
            path: 'points-mall',
            component: { template: '<router-view />'},
            meta: {
                title: '积分管理',
                showHeader: true,
                showTabs: true
            },
            children: [
                { 
                    component: () => import('@/views/contentManager/points-mall/prize-warehouse/view.vue'),
                    path: 'prize-warehouse',
                    meta: { 
                        name: '奖品库',
                        accessId: '200713',
                        btnsAccess: { view: '200715', add: '200716', modify: '200717', export: '200718' }
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-prize/view.vue'),
                    path: 'new-prize/add',
                    meta: {
                        title: '添加奖品'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-prize/view.vue'),
                    path: 'new-prize/modify',
                    meta: {
                        title: '编辑奖品'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-prize/view.vue'),
                    path: 'new-prize/view',
                    meta: {
                        title: '查看奖品'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/exchange-record/view.vue'),
                    path: 'exchange-record',
                    meta: { 
                        name: '兑换记录',
                        accessId: '200714',
                        btnsAccess: { view: '200719', modify: '200720', export: '200721' }
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/exchange-record-detail/view.vue'),
                    path: 'exchange-record-detail',
                    meta: {
                        title: '积分兑换详情',
                        btnsAccess: { modify: '200720'}
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/task-management/view.vue'),
                    path: 'task-management',
                    meta: { 
                        name: '任务管理',
                        accessId: '201396',
                        btnsAccess: { view: '201398', add: '201399', modify: '201400', task: '201401' }
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-task/view.vue'),
                    path: 'new-task/add',
                    meta: {
                        title: '新建任务'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-task/view.vue'),
                    path: 'new-task/modify',
                    meta: {
                        title: '编辑任务'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-task/view.vue'),
                    path: 'new-task/view',
                    meta: {
                        title: '查看任务'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/task-detail/view.vue'),
                    path: 'task-detail/task',
                    meta: {
                        title: '任务完成记录'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/points-out/view.vue'),
                    path: 'points-out',
                    meta: { 
                        name: '积分发放',
                        accessId: '201397',
                        btnsAccess: { view: '201402', add: '201403', modify: '201404', delete: '201405' }
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-points/view.vue'),
                    path: 'new-points/add',
                    meta: {
                        title: '积分发放'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-points/view.vue'),
                    path: 'new-points/modify',
                    meta: {
                        title: '编辑积分发放'
                    }
                },
                { 
                    component: () => import('@/views/contentManager/points-mall/new-points/view.vue'),
                    path: 'new-points/view',
                    meta: {
                        title: '查看积分发放'
                    }
                },
            ]
        },
        {
            path: "workconfig",
            name: 'workconfig',
            meta: {
                title: "作品展示配置",
                pagetitle: "作品展示配置"
            },
            component: () => import('@/views/contentManager/workconfig.vue'),
        },
        {
            path: "workconfig/newworkconfig",
            name: 'newworkconfig',
            meta: {
                title: "新建专题",
                pagetitle: "作品展示配置"
            },
            component: () => import('@/views/contentManager/newworkconfig.vue'),
        },
        {
            path: "workconfig/editworkconfig",
            name: 'editworkconfig',
            meta: {
                title: "编辑专题",
                pagetitle: "作品展示配置"
            },
            component: () => import('@/views/contentManager/newworkconfig.vue'),
        },
        {
            path: "holdAll",
            name: 'holdAll',
            meta: {
                title: "运营工具箱",
                pagetitle: "工具箱",
                showHeader: true,
                btnsAccess: {
                    invitFriendsRewardSettings: ''
                }
            },
            component: () => import('@/views/contentManager/holdAll.vue'),
        },
        {
            path: "holdAll/holdAlltab",
            name: 'holdAlltab',
            meta: {
                title: "运营工具箱 / 首次上传原创作品+认证奖励",
                pagetitle: "运营工具箱"
            },
            component: () => import('@/views/contentManager/holdAlltab.vue'),
        },
        {
            path: "invite-friends-reward-settings",
            meta: {
                title: "好友行为奖励设置",
                showHeader: true
            },
            component: () => import('@/views/contentManager/tools/invite-friends-reward-settings/view.vue'),
        },
        {
            path: "homeBanner/addHomeBanner",
            name: 'addHomeBanner',
            meta: {
                title: "首页banner / 新建banner素材"
            },
            component: () => import('@/views/contentManager/addHomeBanner.vue'),
        },
        {
            path: "homeBanner/editHomeBanner",
            name: 'editHomeBanner',
            meta: {
                title: "首页banner / 编辑banner素材"
            },
            component: () => import('@/views/contentManager/addHomeBanner.vue'),
        },
        {
            path: "homeBanner/addbannerScheme",
            name: 'addbannerScheme',
            meta: {
                title: "首页banner / 新建banner方案"
            },
            component: () => import('@/views/contentManager/addbannerScheme.vue'),
        },
        {
            path: "homeBanner/seebannerScheme",
            name: 'seebannerScheme',
            meta: {
                title: "首页banner / 查看banner方案"
            },
            component: () => import('@/views/contentManager/seebannerScheme.vue'),
        },
        {
            path: "homeBanner/editbannerScheme",
            name: 'editbannerScheme',
            meta: {
                title: "首页banner / 编辑banner方案"
            },
            component: () => import('@/views/contentManager/seebannerScheme.vue'),
        },
        {
            path: "hotWordSearch",
            name: 'hotWordSearch',
            meta: {
                title: "热门搜素词",
                pagetitle: "热门搜素词"
            },
            component: () => import('@/views/contentManager/hotWordSearch.vue'),
        },
        {
            path: "hotWordSearch/newhotword",
            name: 'newhotword',
            meta: {
                title: "热门搜素词 / 新建干预任务"
            },
            component: () => import('@/views/contentManager/newhotword.vue'),
        },
        {
            path: "hotWordSearch/edithotword",
            name: 'edithotword',
            meta: {
                title: "热门搜素词 / 编辑干预任务"
            },
            component: () => import('@/views/contentManager/newhotword.vue'),
        },
        {
            path: "recommendedActivities",
            name: 'recommendedActivities',
            meta: {
                title: "我的收益-推荐活动",
                pagetitle: "我的收益-推荐活动"
            },
            component: () => import('@/views/contentManager/recommendedActivities.vue'),
        },
        {
            path: "projectrecommende",
            name: 'projectrecommende',
            meta: {
                title: "我的收益-推荐项目",
                pagetitle: "我的收益-推荐项目"
            },
            component: () => import('@/views/contentManager/projectrecommende.vue'),
        },
        {
            path: "projectrecommende/newprojectrecommende",
            name: 'newprojectrecommende',
            meta: {
                title: "新建页面",
                pagetitle: "我的收益-推荐项目"
            },
            component: () => import('@/views/contentManager/newprojectrecommende.vue'),
        },
        
        {
            path: "projectrecommende/editprojectrecommende",
            name: 'editprojectrecommende',
            meta: {
                title: "编辑页面",
                pagetitle: "我的收益-推荐项目"
            },
            component: () => import('@/views/contentManager/newprojectrecommende.vue'),
        },
        {
            path: "recommendedActivities/newrecommendedActivities",
            name: 'newrecommendedActivities',
            meta: {
                title: "我的收益-推荐活动 / 新建干预任务"
            },
            component: () => import('@/views/contentManager/newrecommendedActivities.vue'),
        },
        {
            path: "recommendedActivities/editrecommendedActivities",
            name: 'editrecommendedActivities',
            meta: {
                title: "我的收益-推荐活动 / 编辑干预任务"
            },
            component: () => import('@/views/contentManager/newrecommendedActivities.vue'),
        },
        {
            path: "listAd",
            name: 'serviceCenter_listAd',
            meta: {
                title: "首页推荐干预",
                pagetitle: "首页推荐干预"
            },
            component: () => import('@/views/contentManager/listAd.vue'),
        },
        {
            path: "newlistAd",
            name: 'serviceCenter_newlistAd',
            meta: {
                title: "首页推荐干预 / 新建推荐干预"
            },
            component: () => import('@/views/contentManager/newlistAd.vue'),
        },
        {
            path: "editlistAd",
            name: 'serviceCenter_editlistAd',
            meta: {
                title: "首页推荐干预 / 编辑推荐干预"
            },
            component: () => import('@/views/contentManager/newlistAd.vue'),
        },
        {
            path: "/type_tube",
            name: 'type_tube',
            meta: {
                title: "类型管理"
            },
            component: () => import('@/views/contentManager/type_tube.vue'),
        },
        {
            path: "/resources_tube",
            name: 'resources_tube',
            meta: {
                title: "资源管理"
            },
            component: () => import('@/views/contentManager/resources_tube.vue'),
        },
        // {
        //     path: "/expediting",
        //     name: 'expediting',
        //     meta: {
        //         title: "催稿上线"
        //     },
        //     component: () => import('@/views/contentManager/expediting.vue'),
        // },
        {
            path: "/new-display-objec",
            name: 'new-display-objec',
            meta: {
                title: "展示对象"
            },
            component: () => import('@/views/contentManager/tools/new-display-object/new-display-object.vue'),
        },
        {
            path: "/new-resources",
            name: 'new-resources',
            meta: {
                title: "资源管理"
            },
            component: () => import('@/views/contentManager/tools/new-resources/new-resources.vue'),
        }
    ]
}